import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Flex, Text, Alert, AlertIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { getGiftedWallet, getWallet } from "../../../../../store/gifts/newWalletSlice";
import GiftWalletModal from "./GiftWalletModal";
import TableWrapper from "../../../../shared/table/TableWrapper";
import Pagination from "../../../../shared/pagination/Pagination";
import { getAllUsers } from "../../../../../store/allusers/userAllSlice";
import { Link } from "react-router-dom";
import theme from "../../../../global/theme";

const NewWalletGifts = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const wallet = useSelector((s) => s.newWallet);

  const [page, setPage] = useState(1);
  const [showGift, setShowGift] = useState(false);

  const columns = [
    {
      key: "owner",
      label: t("pages.gifts.owner"),
      render: (value, row) =>
        (
          <Link to={`/owner/owners/${row.owner?._id}`}>
            <span
              style={{
                color: theme.navy,
                textDecoration: "underline",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              {row?.owner?.name}
            </span>
          </Link>
        ) || "-",
    },
    { key: "amount", label: t("pages.gifts.amount") },
    { key: "createdAt", label: t("pages.gifts.date"), isDate: true },
  ];

  useEffect(() => {
    dispatch(getGiftedWallet({ page }));
  }, [dispatch, page]);

  useEffect(() => {
    // preload owners list
    dispatch(getAllUsers({ page: 1, role: "owner" }));
  }, [dispatch]);

  return (
    <>
      {wallet.error && (
        <Alert status="error" mb={4}>
          <AlertIcon />
          {wallet.error}
        </Alert>
      )}

      <Flex mb={4} gap={4}>
        <Button colorScheme="red" onClick={() => setShowGift(true)}>
          {t("pages.gifts.gift_wallet")}
        </Button>
      </Flex>

      {wallet.data?.length ? (
        <TableWrapper
          columns={columns}
          data={wallet.data}
          options={{
            showActions: false,
            hideRowNumber: false,
            page,
          }}
        />
      ) : (
        <Flex h="150px" align="center" justify="center">
          <Text color="gray.400">{t("general.no_data")}</Text>
        </Flex>
      )}

      <Flex justify="flex-end" mt={3}>
        <Pagination
          page={page}
          itemsCount={Number(wallet?.itemsCount) || 0}
          onChange={setPage}
        />
      </Flex>

      {showGift && (
        <GiftWalletModal
          onClose={() => setShowGift(false)}
          onDone={() => {
            setShowGift(false);
            dispatch(getGiftedWallet({ page: 1 }));
            setPage(1);
          }}
        />
      )}
    </>
  );
};
export default NewWalletGifts;
